import { FormikRadioField as RadioGroupInput } from "./RadioGroupInput";
export default RadioGroupInput;



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/RadioGroupInput/index.tsx
// module id = 1473
// module chunks = 0